import { Injectable } from "@angular/core";
import { environment, environmentPingId, pingIdToken } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APICustomerBasicDataService {
    ApiURL: string = "";
    ApiURLDxp: string = '';
    constructor(private http: HttpClient, public helperService: HelperService) {
        this.ApiURL = environment.customerBasicDataUrl + 'CustomerBasicData/';
        this.ApiURLDxp = environmentPingId.PingIdvehicleDataUrl + 'customer-basic-data/';
    }

    public get(id: any): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        if (id !== null && id !== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(id), requestOptions);
        } else {
            return this.http.get(this.ApiURL, requestOptions);
        }
    }

    public getForCoutry(id: any): Observable<any> {
        const url = this.ApiURLDxp + "info"
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.helperService.TokenBooking}`,
            'x-apikey': pingIdToken.clientId,
        })
        const requestOptions = {
          headers: headers,
        };
        const body: any = {
            countryid: id
        }
        return this.http.post(url, body, requestOptions);
    }

    public getForIdCustomerVehicle(id: any): Observable<any> {
        const url = this.ApiURLDxp + "info";
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.helperService.TokenBooking}`,
            'x-apikey': pingIdToken.clientId,
        })
        const requestOptions = {
          headers: headers,
        };
        const body: any = {
            customerid: id
        };

        return this.http.post(url, body, requestOptions);
    }

    public postUpdateCustomer(data): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        let url = this.ApiURL+"UpdateCustomerDataJson"
        const requestOptions = {
          headers: headers,
        };

        return this.http.post<any>(url, data, requestOptions)
    }

    public postCreateCustomer(data): Observable<any> {
        const url = this.ApiURLDxp + "create"
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.helperService.TokenBooking}`,
            'x-apikey': pingIdToken.clientId,
        })
        const requestOptions = {
          headers: headers,
        };
        const body: any = data;
        return this.http.post(url, body, requestOptions);
    }

    public put(data): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
          headers: headers,
        };

        return this.http.put<any>(this.ApiURL, data, requestOptions)
    }

    public deleteCustomer(id:number):  Observable<any>{
        const url = this.ApiURLDxp + "delete";
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.helperService.TokenBooking}`,
            'x-apikey': pingIdToken.clientId,
        })
        const requestOptions = {
          headers: headers,
        };
        const body: any = {
            CustomerId: id
        };

        return this.http.post(url, body, requestOptions);
    }
}
